import * as React from "react";
import Modal, { useModalContext } from "components/modal";
import { Button, SubtleButton } from "components/button";
import styled from "styled-components";
import { useTranslation } from 'react-i18next';

type Props = {
  message?: React.ReactNode;
};

const useAreYouSure = () => {
  const { t } = useTranslation();
  const tBase = "components.areYouSure";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const { setModal } = useModalContext();

  const handleConfirm = (action: any) => {
    action();
    setModal();
  };
/**const that handles a cancel  */
  const handleCancel = () => {
    setModal();
  };

  const activate = (action: () => void, props?: Props) => {
    setModal({
      component: (
        <Con>
          <Message>
            {props?.message ?? tr("Are you sure you want to perform this action?")}
          </Message>
          <div>
            <SubtleButton onClick={handleCancel}>{tr("Cancel")}</SubtleButton>
            <Button primary onClick={() => handleConfirm(action)}>
              {tr("Confirm")}
            </Button>
          </div>
        </Con>
      ),
      label: tr("Confirmation"),
    });
  };

  return { activate };
};

const Message = styled.div`
  font-size: 0.9rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.85);
  max-height: 50vh;
  overflow-y: auto;
`;

const Con = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  > div:last-child {
    display: flex;
    margin-top: 1rem;
    justify-content: flex-end;
    > button {
      margin-left: 0.5rem;
    }
  }
`;
export { useAreYouSure };
